<h1>{{ 'SuccessPageTitle' | localize }}</h1>
<div>
    <p>{{ message }}</p>
</div>
